/**
 * Re-scan the DOM for Okendo widgets after dynamic content has been
 * injected (e.g. predictive search results, filtered PLP, related
 * products). Okendo hydrates widgets on initial page load, so new
 * [data-oke-star-rating] elements added later need a manual reinit.
 */
const reinitOkendoWidgets = () => {
  window.okeWidgetApi?.initAllWidgets?.();
};

export default reinitOkendoWidgets;
